import React from 'react';

import type { MarkdownComponentProps } from '../ChatPanelMarkdown';

/**
 * Custom code block rendering.
 *
 * This is just a pass-through now but is necessary. We handle the rendering of
 * the `pre` as a container in the `code` element rendering. This allows us to
 * have cleaner rendering when the suggestion is empty.
 */
export const PreElement = React.memo(function PreElement({
  children,
}: MarkdownComponentProps<HTMLPreElement>) {
  return <div>{children}</div>;
});

export const PreElementDrafting = React.memo(function PreElementDrafting({
  children,
}: MarkdownComponentProps<HTMLPreElement>) {
  return <pre>{children}</pre>;
});
